let mobileLogin = new window.MobileLogin({
	source: 'passport'
});

export default {
	getAuthCode: function(tel, imgCode) {
		return new Promise(function(resolve, reject) {
			//提交
			mobileLogin.getCode({
				mobile: tel,
				voicetype: 0,
				validcode: imgCode,
				callback: function(result) {
					resolve(result);
				}
			});
		});
	},

	freshValidateCode: function() {
		return mobileLogin.freshValidateCode();
	},

	loginCommit: function(tel, code) {
		return new Promise(function(resolve, reject) {
			mobileLogin.loginCommit({
				mobile: tel,
				mobilecode: code,
				callback: function(result) {
					resolve(result);
				}
			});
		});
	}
};



// WEBPACK FOOTER //
// ./src/module/basic/util/login.js